(() => {
  document.querySelectorAll('[data-featured-product-scroll]').forEach(section => {
    const track = section.querySelector('[class*="ai-featured-collection-grid-"]');
    if (!track) return;

    const deferredCards = Array.from(track.querySelectorAll('template[data-deferred-product-card]'));
    const desktopHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const loadSecondaryImage = wrapper => {
      if (!desktopHover.matches || !wrapper) return;
      const image = wrapper.querySelector('img[data-hover-src]');
      if (!image) return;
      image.addEventListener('load', () => wrapper.classList.add('secondary-ready'), { once: true });
      image.src = image.dataset.hoverSrc;
      if (image.dataset.hoverSrcset) image.srcset = image.dataset.hoverSrcset;
      if (image.dataset.hoverSizes) image.sizes = image.dataset.hoverSizes;
      image.removeAttribute('data-hover-src');
      image.removeAttribute('data-hover-srcset');
      image.removeAttribute('data-hover-sizes');
    };
    track.addEventListener('mouseover', event => {
      loadSecondaryImage(event.target.closest('[class*="ai-product-image-wrapper-"]'));
    }, { passive: true });

    let deferredIndex = 0;
    const appendBatch = () => {
      const batch = deferredCards.slice(deferredIndex, deferredIndex + 4);
      if (!batch.length) return false;
      batch.forEach(template => {
        track.insertBefore(template.content.cloneNode(true), template);
        template.remove();
      });
      deferredIndex += batch.length;
      return true;
    };

    const move = direction => {
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      const atStart = track.scrollLeft <= 8;
      if (direction > 0 && atEnd && appendBatch()) {
        window.requestAnimationFrame(() => track.scrollBy({ left: track.clientWidth * 0.82, behavior: 'smooth' }));
      }
      else if (direction > 0 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
      else if (direction < 0 && atStart) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      else track.scrollBy({ left: direction * track.clientWidth * 0.82, behavior: 'smooth' });
    };

    section.querySelector('[data-carousel-previous]')?.addEventListener('click', () => move(-1));
    section.querySelector('[data-carousel-next]')?.addEventListener('click', () => move(1));

    let scrollFrame = 0;
    track.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = 0;
        const remaining = track.scrollWidth - track.scrollLeft - track.clientWidth;
        if (remaining < track.clientWidth * 0.6) appendBatch();
      });
    }, { passive: true });

    let visible = false;
    let hovering = false;
    let timer = 0;
    const stop = () => { window.clearInterval(timer); timer = 0; };
    const start = () => {
      stop();
      if (visible && !hovering && !document.hidden) timer = window.setInterval(() => move(1), 4500);
    };

    section.addEventListener('mouseenter', () => { hovering = true; stop(); });
    section.addEventListener('mouseleave', () => { hovering = false; start(); });
    document.addEventListener('visibilitychange', start);

    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) start();
      else stop();
    }, { rootMargin: '200px 0px', threshold: 0.05 });
    observer.observe(section);
  });
})();
